import store from './store'

interface ChartFields {
    [layer: number]: string
}
interface ChartEvents {
    [layer: number]: {
        [key: string]: object
    }
}
interface ChartState {
    fields: ChartFields
    events: ChartEvents
}
const reducer = (
    state = {
        fields: {},
        events: {}
    } as ChartState,
    message
) => {
    if (!message) {
        return state
    }

    if (message.baseline && message.type !== 'event') {
        return state
    }
    switch (message.type) {
        case 'start':
            const fields = {
                ...state.fields,
                [message.layer]: message.events.select
            }
            store.dispatch({ type: message.type, message: fields })
            return {
                fields,
                events: {
                    ...state.events,
                    [message.layer]: []
                }
            }

        case 'event':
            return {
                ...state,
                events: {
                    ...state.events,
                    [message.layer]: message.events
                }
            }
        default:
            return state
    }
}
export { reducer, ChartState, ChartFields, ChartEvents }
